import React, { useEffect, useRef } from 'react';
import { Button, Grid, Typography } from '@mui/material';
import { HotelOptionDetailDestinationMultiple } from 'features/quotation/types';

interface HotelOptionItemProps {
	isSelected: boolean;
	hotel: HotelOptionDetailDestinationMultiple;
	onSelect: () => void;
	disabled?: boolean;
}

export function HotelOptionItem({ isSelected, hotel, onSelect, disabled }: HotelOptionItemProps): JSX.Element {
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (isSelected && ref.current) {
			ref.current.scrollIntoView({
				behavior: 'smooth',
				inline: 'center',
				block: 'nearest',
			});
		}
	}, [isSelected]);

	return (
		<Grid sx={{ display: 'flex', alignItems: 'stretch' }} item ref={isSelected ? ref : null}>
			<Button
				size="small"
				sx={{
					width: '210px',
					overflow: 'hidden',
					height: '42px',
					justifyContent: 'flex-start',
					textAlign: 'left',
					borderRadius: '10px',
					borderWidth: isSelected ? '2px' : '1px',
					backgroundColor: disabled
						? 'rgba(49, 25, 75, 0.025)'
						: isSelected
						? 'rgba(49, 25, 75, 0.08)'
						: 'rgba(255, 255, 255, 0.90)',
					boxShadow: isSelected ? '0 4px 14px rgba(49, 25, 75, 0.16)' : 'none',
					borderColor: isSelected ? 'primary.main' : 'rgba(49, 25, 75, 0.18)',
					opacity: disabled ? 0.55 : 1,
				}}
				variant="outlined"
				onClick={onSelect}
				color="primary"
				disabled={disabled}
			>
				<Typography
					fontSize={12}
					fontWeight={isSelected ? 'bold' : 500}
					minHeight="34px"
					display="flex"
					flexDirection="column"
					alignItems="flex-start"
					justifyContent="center"
					minWidth="170px"
					maxWidth="210px"
					component="p"
					sx={{
						overflow: 'hidden',
						whiteSpace: 'nowrap',
						textOverflow: 'ellipsis',
					}}
				>
					{isSelected && (
						<Typography component="span" fontSize={9} color="secondary" fontWeight={800} lineHeight={1}>
							Seleccionado
						</Typography>
					)}
					{disabled && (
						<Typography component="span" fontSize={9} color="text.secondary" fontWeight={800} lineHeight={1}>
							No disponible
						</Typography>
					)}
					{hotel.hotelName}
				</Typography>
			</Button>
		</Grid>
	);
}
